import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["channelField", "keywordFields", "workspaceSelect", "channelSelect", "channelLoading"]

  connect() {
    console.log('[SlackListenerForm] Controller connected')
    console.log('[SlackListenerForm] Has workspaceSelect:', this.hasWorkspaceSelectTarget)
    console.log('[SlackListenerForm] Has channelSelect:', this.hasChannelSelectTarget)
    
    if (this.hasWorkspaceSelectTarget) {
      console.log('[SlackListenerForm] Workspace value:', this.workspaceSelectTarget.value)
    }
    
    this.updateFieldVisibility()
    // Load channels for initially selected workspace
    if (this.hasWorkspaceSelectTarget && this.workspaceSelectTarget.value) {
      console.log('[SlackListenerForm] Loading channels on connect')
      this.loadChannels()
    }
  }

  typeChanged(event) {
    this.updateFieldVisibility()
  }

  workspaceChanged(event) {
    this.loadChannels()
  }

  updateFieldVisibility() {
    const selectedType = this.element.querySelector('input[name="slack_listener[listener_type]"]:checked')?.value

    // Hide all conditional fields first
    if (this.hasChannelFieldTarget) {
      this.channelFieldTarget.classList.add("hidden")
    }
    if (this.hasKeywordFieldsTarget) {
      this.keywordFieldsTarget.classList.add("hidden")
    }

    // Show relevant fields based on type
    switch (selectedType) {
      case "channel":
        if (this.hasChannelFieldTarget) {
          this.channelFieldTarget.classList.remove("hidden")
        }
        break
      case "keyword":
        if (this.hasKeywordFieldsTarget) {
          this.keywordFieldsTarget.classList.remove("hidden")
        }
        break
      // dm and mention don't need additional fields
    }
  }

  async loadChannels() {
    console.log('[SlackListenerForm] loadChannels called')
    
    if (!this.hasWorkspaceSelectTarget || !this.hasChannelSelectTarget) {
      console.log('[SlackListenerForm] Missing targets, workspace:', this.hasWorkspaceSelectTarget, 'channel:', this.hasChannelSelectTarget)
      return
    }

    const installationId = this.workspaceSelectTarget.value
    console.log('[SlackListenerForm] Installation ID:', installationId)
    
    if (!installationId) {
      console.log('[SlackListenerForm] No installation ID, aborting')
      return
    }

    // Show loading state
    if (this.hasChannelLoadingTarget) {
      this.channelLoadingTarget.classList.remove("hidden")
    }
    this.channelSelectTarget.disabled = true

    // Save current selection
    const currentValue = this.channelSelectTarget.value
    const url = `/settings/slack_installations/${installationId}/channels`
    console.log('[SlackListenerForm] Fetching channels from:', url)

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      console.log('[SlackListenerForm] Response status:', response.status)
      
      if (!response.ok) throw new Error(`Failed to fetch channels: ${response.status}`)

      const channels = await response.json()
      console.log('[SlackListenerForm] Channels received:', channels.length, channels)

      // Update the select options
      this.channelSelectTarget.innerHTML = '<option value="">Select a channel...</option>'

      if (channels.length === 0) {
        console.log('[SlackListenerForm] No channels available')
        const option = document.createElement('option')
        option.value = ''
        option.textContent = 'No channels available (invite the bot to a channel)'
        option.disabled = true
        this.channelSelectTarget.appendChild(option)
      } else {
        channels.forEach(channel => {
          const option = document.createElement('option')
          option.value = channel.id
          option.textContent = `#${channel.name}${channel.is_private ? ' (private)' : ''}`
          option.dataset.channelName = channel.name
          // Restore selection if this was the previously selected channel
          if (channel.id === currentValue) {
            option.selected = true
          }
          this.channelSelectTarget.appendChild(option)
        })
        console.log('[SlackListenerForm] Added', channels.length, 'channel options')
      }
    } catch (error) {
      console.error('[SlackListenerForm] Error loading channels:', error)
      this.channelSelectTarget.innerHTML = '<option value="">Error loading channels</option>'
    } finally {
      // Hide loading state
      if (this.hasChannelLoadingTarget) {
        this.channelLoadingTarget.classList.add("hidden")
      }
      this.channelSelectTarget.disabled = false
    }
  }

  // Update hidden channel_name field when channel is selected
  channelSelected(event) {
    const select = event.target
    const selectedOption = select.options[select.selectedIndex]
    const channelNameInput = this.element.querySelector('input[name="slack_listener[channel_name]"]')
    
    if (channelNameInput && selectedOption.dataset.channelName) {
      channelNameInput.value = selectedOption.dataset.channelName
    }
  }
}
